import { TextField } from '@refinedev/antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Shipment } from '@/model/Logistic/Shipment/Shipment';
import { Country, phoneNumberMeta } from '@/utils/phoneNumbers';

interface ShipmentShowAddressProps {
  record?: Shipment;
}

const ShipmentShowAddress = (props: ShipmentShowAddressProps) => {
  const { t } = useTranslation();
  const { record } = props;
  const countryCode = useMemo(() => {
    return Country[record?.receiver_localidad?.provincia?.pais?.id];
  }, [record]);

  return (
    <div className="ShipmentShowDataCard">
      <div className="ShipmentShowData">
        <b>{t('País')}</b>
        <TextField value={record?.receiver_localidad?.provincia?.pais?.nombre} />
      </div>
      <div className="ShipmentShowData">
        <b>{t('Provincia')}</b>
        <TextField value={record?.receiver_localidad?.provincia?.nombre} />
      </div>
      <div className="ShipmentShowData">
        <b>{t('Localidad')}</b>
        <TextField value={record?.receiver_localidad?.nombre} />
      </div>
      <div className="ShipmentShowData">
        <b>{t('Código postal')}</b>
        <TextField value={record?.receiver_postal_code ? record?.receiver_postal_code : '-'} />
      </div>
      <div className="ShipmentShowData">
        <b>{t('Dirección')}</b>
        <TextField value={record?.receiver_address ? record?.receiver_address : '-'} />
      </div>
      <div className="ShipmentShowData">
        <b>{t('Email')}</b>
        <TextField value={record?.receiver_email ? record?.receiver_email : '-'} />
      </div>
      <div className="ShipmentShowData">
        <b>{t('Número de teléfono')}</b>
        <TextField
          value={
            record?.receiver_phone && countryCode
              ? `${phoneNumberMeta[countryCode].phoneCountry} ${record?.receiver_phone}`
              : '-'
          }
        />
      </div>
      <div className="ShipmentShowData">
        <b>{t('Nombre y apellido del destinatario')}</b>
        <TextField value={record?.receiver_name} />
      </div>
      {record?.receiver_delivery_instructions && (
        <div className="ShipmentShowData">
          <b>{t('Instrucciones para la entrega')}</b>
          <TextField value={record?.receiver_delivery_instructions} />
        </div>
      )}
    </div>
  );
};

export default ShipmentShowAddress;
